const lbaBreadCrumb = angular.module('app.lbaBreadCrumb', []);

lbaBreadCrumb.controller('lbaBreadCrumbCtrl', require('./lbaBreadCrumbCtrl'));
lbaBreadCrumb.directive('lbaBreadCrumb', require('./lbaBreadCrumbDir'));

export default lbaBreadCrumb;



// WEBPACK FOOTER //
// ./src/components/lbaBreadCrumb/index.js